import { render, staticRenderFns } from "./EditFile.vue?vue&type=template&id=2ed0bff9&"
import script from "./EditFile.vue?vue&type=script&lang=js&"
export * from "./EditFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports